var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson2Fill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "133.75px",
    height: "88.5px",
    viewBox: "0 0 133.75 88.5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "person.2.fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person.2.fill",
    transform: "translate(-0, 0)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.6252,57.1079 C48.3892,64.3104 43.75,73.5148 43.75,81.8125 C43.75,84.1481 44.2067,86.4569 45.3338,88.5 L9.125,88.5 C2.4375,88.5 3.55271368e-15,85.875 3.55271368e-15,81.4375 C3.55271368e-15,67.9375 13.875,51.5 36,51.5 C44.0698,51.5 51.0401,53.6744 56.6252,57.1079 Z M53.1875,25.0625 C53.1875,35.75 45.125,44 36,44 C26.9375,44 18.8125,35.75 18.8125,25.1875 C18.8125,14.5625 26.9375,6.6875 36,6.6875 C45.125,6.6875 53.1875,14.375 53.1875,25.0625 Z",
    id: "Shape",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.375,42.875 C102.875,42.875 112.125,33.4375 112.125,21.125 C112.125,8.875 102.875,0 92.375,0 C81.9375,0 72.6875,9.125 72.6875,21.25 C72.6875,33.4375 81.9375,42.875 92.375,42.875 Z M62.1875,88.5 L122.625,88.5 C131,88.5 133.75,86.125 133.75,81.8125 C133.75,69.125 117.875,51.625 92.375,51.625 C66.9375,51.625 51.0625,69.125 51.0625,81.8125 C51.0625,86.125 53.8125,88.5 62.1875,88.5 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson2Fill);
export default __webpack_public_path__ + "static/media/person.2.fill.89fa1423ae722c0fd83bc6a95911fbcb.svg";
export { ForwardRef as ReactComponent };